
import React from 'react';
import { siteConfig } from '../config/site';
import { PlayCircle, Film } from 'lucide-react';

const GalleryStrip: React.FC = () => {
  return (
    <section id="gallery" className="relative bg-primary py-32 px-6 overflow-hidden border-y border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20 reveal reveal-up">
          <h3 className="text-accent font-bold tracking-[0.4em] uppercase text-[10px] mb-4">The Archive</h3>
          <h2 className="text-4xl sm:text-5xl font-serif font-bold mb-8 uppercase tracking-tight">MASTERY IN MOTION</h2>
          <div className="w-20 h-px bg-accent/20 mx-auto"></div>
        </div>

        {/* Vertical Reel Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {siteConfig.videos.masteryReels.map((video, idx) => (
            <div key={idx} className={`reveal reveal-up relative group p-1 bg-accent/5 border border-white/5 hover:border-accent/40 transition-all duration-700 shadow-2xl overflow-hidden`}>
              {/* Premium Video Container */}
              <div className="aspect-[9/16] w-full bg-black overflow-hidden relative">
                <iframe 
                  src={`https://player.vimeo.com/video/${video.id}?badge=0&autopause=0&player_id=0&app_id=58479`}
                  className="absolute inset-0 w-full h-full grayscale-[0.2] group-hover:grayscale-0 transition-all duration-700 scale-[1.05]"
                  frameBorder="0" 
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" 
                  referrerPolicy="strict-origin-when-cross-origin" 
                  title={video.title}
                ></iframe>
                
                {/* Overlay Details */}
                <div className="absolute top-4 left-4 z-20">
                  <span className="bg-black/80 backdrop-blur-md px-3 py-1 text-[8px] text-accent font-black uppercase tracking-[0.3em] border border-accent/20">
                    Reel 0{idx + 1}
                  </span>
                </div>
                
                {/* Visual Glow */}
                <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>

              {/* Caption */}
              <div className="p-6 bg-secondary/40 backdrop-blur-md border-t border-white/5 flex items-center justify-between">
                <div>
                  <h4 className="text-white font-serif italic text-xl group-hover:text-accent transition-colors">
                    {video.title}
                  </h4>
                  <p className="text-[9px] text-white/30 uppercase tracking-widest font-black mt-1">Santi Bladez Signature Series</p>
                </div>
                <Film size={20} className="text-accent/20 group-hover:text-accent transition-colors" />
              </div>

              {/* Aesthetic Corner Accents */}
              <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-accent/0 group-hover:border-accent/40 transition-all"></div>
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-accent/0 group-hover:border-accent/40 transition-all"></div>
            </div>
          ))}
        </div>

        {/* Background Atmosphere */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[radial-gradient(circle_at_center,_rgba(205,127,50,0.03)_0%,_transparent_60%)] pointer-events-none -z-10"></div>
      </div>
    </section>
  );
};

export default GalleryStrip;
